<template>
  <el-card>
    <el-row class="rocket__title">房间火箭管理</el-row>
    <el-row class="rocket__tags">
      <div
        :class="['levelList', tagType === item.level ? 'active' : '']"
        v-for="(item, index) in levelList"
        :key="index"
        @click="tagType = item.level"
      >
        {{ item.showName }}
      </div>
      <el-button
        type="primary"
        @click="
          () => {
            rocketType = 1
            rocketConfigShow = true
          }
        "
        plain
        >添加火箭挡位</el-button
      >
      <el-button
        type="success"
        @click="
          () => {
            if (levelConfigList && levelConfigList) {
              rocketType = 2
              rocketConfig = levelConfigList
              rocketConfigShow = true
            }
          }
        "
        plain
        >修改</el-button
      >
    </el-row>
    <el-row class="rocket__search">
      <span>LV{{ tagType }} 消耗礼物金币数：</span>
      <el-input
        v-if="levelConfigList"
        v-model="levelConfigList.rewardCondition"
        :disabled="true"
        style="width: 150px"
      ></el-input>
    </el-row>
    <el-row>
      <span>奖励类型：</span>
      <el-select
        v-model="rewardConfig.rewardBO.itemType"
        clearable
        filterable
        placeholder="请选择"
        style="width: 120px; margin-right: 10px"
      >
        <el-option
          v-for="(item, index) in rewardTypes"
          :key="index"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>奖励ID：</span>
      <el-input
        v-model.number="rewardConfig.rewardBO.itemId"
        type="number"
        style="width: 150px; margin-right: 10px"
      ></el-input>
      <span>奖品数量：</span>
      <el-input
        v-model.number="rewardConfig.rewardBO.itemNum"
        type="number"
        style="width: 100px; margin-right: 10px"
      ></el-input>
      <span>奖励数量：</span>
      <el-input
        v-model.number="rewardConfig.rewardNums"
        type="number"
        style="width: 100px; margin-right: 10px"
      ></el-input>
    </el-row>
    <!-- 显示奖励图片和名称（仅在编辑模式下） -->
    <el-row v-if="isEdit && rewardConfig.rewardBO.itemIcon">
      <span>奖励图片：</span>
      <el-image
        style="width: 100px; height: auto; margin-right: 10px"
        :src="rewardConfig.rewardBO.itemIcon"
        :preview-src-list="[rewardConfig.rewardBO.itemIcon]"
      ></el-image>
      <span>奖励名称：</span>
      <span style="margin-right: 10px">{{ rewardConfig.rewardBO.itemName || '暂无' }}</span>
    </el-row>
    <el-row>
      <span>领取条件：</span>
      <el-input
        v-model.number="rewardConfig.conditionMin"
        type="number"
        style="width: 100px; margin-right: 10px"
      ></el-input>
      <span>-</span>
      <el-input
        v-model.number="rewardConfig.conditionMax"
        type="number"
        style="width: 100px; margin: 0 10px"
      ></el-input>
      <span>领取概率(小数)：</span>
      <el-input
        v-model.number="rewardConfig.rate"
        type="number"
        style="width: 100px; margin-right: 10px"
      ></el-input>
      <span>是否为MVP：</span>
      <el-switch
        v-model="rewardConfig.mvpReward"
        active-color="#13ce66"
        :active-value="1"
        :inactive-value="0"
        style="margin-right: 10px"
      ></el-switch>
      <span>排序：</span>
      <el-input
        v-model.number="rewardConfig.sortOrder"
        type="number"
        style="width: 100px; margin-right: 10px"
      ></el-input>
      <!-- <span>是否有效：</span>
      <el-switch
        v-model="rewardConfig.valid"
        active-color="#13ce66"
        :active-value="1"
        :inactive-value="0"
        style="margin-right: 10px"
      ></el-switch> -->
      <el-button type="primary" @click="submitAddReward" plain
        >{{ isEdit ? '编辑奖励' : '新增奖励' }}</el-button
      >
      <el-button
        type="primary"
        @click="
          rewardConfig = {
            mvpReward: 0,
            sortOrder: null,
            conditionMin: null,
            conditionMax: null,
            rate: null,
            rewardNums: null,
            valid: 1,
            rewardBO: {
              itemId: null,
              itemNum: null,
              itemType: null,
            },
          }
          isEdit = false
        "
        plain
        >置空</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table
        border
        :data="tableList"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column label="物品类型" align="center">
          <template slot-scope="scope">
            {{
              rewardTypes.find(
                (item) => scope.row.rewardBO.itemType == item.value
              ).name
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="奖励类型"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.mvpReward === 1 ? 'mvp奖励' : '其它奖励' }}
          </template>
        </el-table-column>
        <el-table-column label="奖励id" align="center">
          <template slot-scope="scope">
            {{ scope.row.rewardBO.itemId}}
          </template>
        </el-table-column>
        <el-table-column label="奖励图片" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: auto"
              :src="scope.row.rewardBO.itemIcon"
              :preview-src-list="[scope.row.rewardBO.itemIcon]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="奖励名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.rewardBO.itemName }}
          </template>
        </el-table-column>
        <el-table-column prop="rewardNums" label="奖励数量" align="center">
        </el-table-column>
        <el-table-column label="奖品数量" align="center">
          <template slot-scope="scope">
            {{ scope.row.rewardBO.itemNum }}
          </template>
        </el-table-column>
        <el-table-column label="领取条件" align="center">
          <template slot-scope="scope">
            {{ scope.row.conditionMin || '' }}~{{
              scope.row.conditionMax || ''
            }}
          </template>
        </el-table-column>
        <el-table-column prop="rate" label="领取概率" align="center">
        </el-table-column>
        <el-table-column sortable prop="sortOrder" label="排序" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-button type="primary" @click="editReward(scope.row)" style="margin-right: 10px"
              >编辑</el-button
            >
            <el-button type="info" @click="deleteReward(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 火箭配置弹窗 -->
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="rocketConfigShow"
      :close-on-press-escape="false"
      title="火箭配置管理"
    >
      <el-row>
        <span>等级：</span>
        <el-input
          v-model.number="rocketConfig.level"
          type="number"
          placeholder="请输入等级"
          style="width: 200px; margin-bottom: 5px"
        ></el-input>
      </el-row>
      <el-row>
        <span>展示名称：</span>
        <el-input
          v-model.trim="rocketConfig.showName"
          placeholder="请输入名称"
          style="width: 200px; margin-bottom: 5px"
        ></el-input>
      </el-row>
      <el-row>
        <span>展示等级：</span>
        <el-input
          v-model.trim="rocketConfig.showLevel"
          placeholder="请输入"
          style="width: 200px; margin-bottom: 5px"
        ></el-input>
      </el-row>
      <el-row>
        <span>开奖条件：</span>
        <el-input
          v-model.number.trim="rocketConfig.rewardCondition"
          type="number"
          placeholder="请输入条件"
          style="width: 200px; margin-bottom: 5px"
        ></el-input>
      </el-row>
      <el-row>
        <span>状态：</span>
        <el-switch
          v-model="rocketConfig.valid"
          active-color="#13ce66"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-row>
      <el-row>
        <el-button @click="resetForm(1)">取消</el-button>
        <el-button type="primary" @click="submit(1)">确认</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      rewardTypes: [],
      levelList: [],
      tagType: 1,
      rocketType: 1,
      rocketConfigShow: false,
      levelConfigList: {
        rewardCondition: 0,
      },
      tableList: [],
      rocketConfig: {
        level: null,
        showName: null,
        showLevel: null,
        rewardCondition: null,
        valid: 1,
      },
      rewardConfig: {
        mvpReward: 0,
        conditionMin: null,
        conditionMax: null,
        rate: null,
        rewardNums: null,
        valid: 1,
        rewardBO: {
          itemId: null,
          itemNum: null,
          itemType: null,
        },
      },
      // 编辑相关数据
      isEdit: false,
    }
  },
  watch: {
    tagType: function (val) {
      this.getAllRocketConfig(val)
    },
  },
  mounted() {
    this.getAllBeforeDate()
  },
  methods: {
    // 排序
    // sortByType(a,b){
    //   console.log(a);
    //   console.log("----");
    //   console.log(b);
    // },
    // 取消
    resetForm(type) {
      if (type === 1) {
        this.rocketConfigShow = false
        this.rocketConfig = {
          level: null,
          showName: null,
          showLevel: null,
          rewardCondition: null,
        }
      }
    },
    // 确认
    submit() {
      if (this.rocketType === 1) {
        this.addRocketConfig(this.rocketConfig)
      } else if (this.rocketType === 2) {
        this.upDateRocketConfig(this.rocketConfig)
      }
    },
    // 获取所有前置数据
    getAllBeforeDate() {
      this.getAllRewardType()
      this.getAllLevel()
      this.getAllRocketConfig()
    },
    // 获取奖励类型
    async getAllRewardType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_reward_type,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('奖励类型获取成功')
        this.rewardTypes = res.data
      }
    },
    // 获取火箭等级
    async getAllLevel() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_level_type,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('火箭等级获取成功')
        this.levelList = res.data
      }
    },
    // 获取火箭配置
    async getAllRocketConfig(level = 1) {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_config_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          level,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('火箭配置获取成功')
        this.levelConfigList = res.data
        this.tableList = res.data.rewardList || []
      }
    },
    // 火箭配置添加
    async addRocketConfig(info) {
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_config_add,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('火箭配置添加成功')
        this.getAllLevel()
        this.getAllRocketConfig(this.tagType)
        this.resetForm(1)
      }
    },
    // 火箭配置修改
    async upDateRocketConfig(info) {
      console.log(info)
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_config_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('火箭配置修改成功')
        this.getAllLevel()
        this.getAllRocketConfig(this.tagType)
        this.resetForm(1)
      }
    },
    // 奖励添加
    async addReward(info) {
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_reward_add,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('奖励添加成功')
        this.getAllRocketConfig(this.tagType)
      }
    },
    // 奖励删除
    async deleteReward(id) {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_reward_delete,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rewardId: id,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('删除成功')
        this.getAllRocketConfig(this.tagType)
      }
    },
    // 新增奖励提交
    submitAddReward() {
      if (!this.levelConfigList.level) return this.$message.error('level不存在')
      const data = JSON.parse(JSON.stringify(this.rewardConfig))
      data.level = this.levelConfigList.level
      
      if (this.isEdit) {
        // 编辑模式
        if (!data.id) {
          return this.$message.error('奖励ID不存在')
        }
        this.updateReward(data)
      } else {
        // 新增模式
        this.addReward(data)
      }
    },
    // 编辑奖励
    editReward(row) {
      this.rewardConfig = JSON.parse(JSON.stringify(row))
      this.isEdit = true
    },
    // 更新奖励
    async updateReward(info) {
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.rocket_reward_update,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('奖励修改成功')
        this.getAllRocketConfig(this.tagType)
        this.resetRewardForm()
      }
    },
    // 重置奖励表单
    resetRewardForm() {
      this.isEdit = false
      this.rewardConfig = {
        mvpReward: 0,
        conditionMin: null,
        conditionMax: null,
        rate: null,
        rewardNums: null,
        valid: 1,
        rewardBO: {
          itemId: null,
          itemNum: null,
          itemType: null,
        },
      }
    },
  },
}
</script>

<style scoped lang="scss">
.rocket {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__tags {
    display: flex;
    gap: 10px;
    .levelList {
      padding: 0 20px;
      height: 40px;
      border: 1px solid #ccc;
      border-radius: 20px;
      cursor: pointer;
      font-size: 12px;
      line-height: 40px;

      &.active {
        background-color: #409eff;
        color: #fff;
      }
    }
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>
